export default __webpack_public_path__ + "static/media/borku-x.cebe1454.svg";